<template>
  <v-dialog
      v-model="open"

      class="dialog"
      max-width="500"
      overlay-opacity="0.8"
  >
    <v-btn class="close-button" color="gray" fab x-small
           @click="open=false">
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <v-card class="panel">
      <v-card-title>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            hide-details
            label="ค้นหา"
            single-line
        ></v-text-field>
      </v-card-title>
      <v-content class="content">
        <v-simple-table v-if="products && products.length>0" class="itemTable" fixed-header>
          <template v-slot:default>
            <thead>
            <tr class="ItemHead">
              <th class="text-left">รายการ</th>
              <th class="text-right d-none d-md-table-cell">ราคา</th>
              <th class="text-center d-none d-md-table-cell">เพิ่ม</th>
            </tr>
            </thead>
            <tbody class="cart-item">
            <tr v-for="(item, index) in products"
                :key="index"
                :currentIndex="index"
                :item="item"
                class="ItemRow"
            >
              <td> {{ item.nickname || item.code }}
              </td>
              <td class="text-right  d-none d-md-table-cell">{{
                  $helper.number_format(item['price_' + price_group], 2, 2)
                }}
              </td>
              <td>
                <v-btn outlined small @click="onClickProduct(item)">เพิ่ม</v-btn>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-content>
    </v-card>
  </v-dialog>
</template>
<style lang="scss" scoped>
.v-dialog {
  margin: 0;
  overflow: visible;
}

.close-button {
  float: right;
  margin-top: 0;

}

.view {
  position: relative;
  /*background: #FF0000;*/
}

.panel {
  margin-top: 16px;

  background: #EEEEEE;
  padding: 1vmin;
  border-radius: 10vmin;
}

.content {
  max-height: 400px;
  overflow: auto;
}

</style>

<script lang="ts">

import {DataProductsArray, FilterProduct, Product} from '@/models/Product'
import {Meta} from '@/models/Response'
import Helper from '@/services/Helper.js'

import {Component, Vue, Watch} from 'vue-property-decorator'


@Component({
  components: {},
})
export default class ProductChooserDialog extends Vue {

  search = ''
  open: boolean = false
  loading: boolean = false

  products: Product[] = []
  filter: FilterProduct = new FilterProduct()
  meta: Meta = new Meta()

  price_group = 1

  onApply: Function = () => {
  }
  onSearch: Function = () => {
  }

  created() {
    this.$root.$on('openProductChooser', this.onOpen)
  }

  onOpen({
           index_no, price_group, onApply, onSearch = () => {
    }, keyword = '',
         }) {
    console.log('calculator mounted')

    this.products = []
    this.onApply = onApply
    this.onSearch = onSearch
    this.open = true
    this.price_group = price_group
    this.search = keyword
    if (keyword != '') {
      this.onSearchChanged(keyword, '')
    }
  }

  onClickProduct(product: Product) {
    this.onApply(product)
    this.open = false
  }

  @Watch('search')
  async onSearchChanged(keyword: string, oldValue: string) {
    console.log('Search change', [oldValue, keyword])

    if (keyword.length >= 3) {
      const url = Helper.setting.product.getListAPI + '?type=F&keyword=' + keyword

      try {
        this.loading = true
        const response = await Helper.get(url).then<{ data: DataProductsArray }>(({data}) => data)
        this.products = response.data
        this.filter = response.filter
        this.meta = response.meta

        this.onSearch(keyword, response)
      } catch (e) {
        alert(e)
      }
      this.loading = true
      // /api/products?type=F&from_date=2020-12-01&to_date=2020-12-28&sort=code
    }

  }
};

</script>
